import CompetencyResultSample from '@common/competencyResultSample';
import CompetencyType from '@components/phs/pacc/results/result/competencyResult/competencyType';
import NotOverYetBanner from '@components/phs/pacc/results/result/competencyResult/notOverYetBanner';
import CompetencyProfile from '@components/phs/pacc/results/result/competencyResult/competencyProfile';
import CompanyRecommend from '@components/phs/pacc/results/result/competencyResult/companyRecommend';
import JobRecommend from '@components/phs/pacc/results/result/competencyResult/jobRecommend';
import InterviewGuide from '@components/phs/pacc/results/result/competencyResult/interviewGuide';
import Share from '@components/phs/pacc/results/result/competencyResult/share';
import Feedback from '@components/phs/pacc/results/result/competencyResult/feedback';
import CopyrightWarning from '@components/phs/pacc/results/result/competencyResult/copyrightWarning';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useEventsParticipationStatus } from '@repository/event/useEvent';
import { EventTypeEnum } from '@domain/constant/event/EventType';
import classNames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classNames.bind(styles);

interface CompetencyResultProps {
  sn: number;
}

const CompetencyResult = ({ sn }: CompetencyResultProps) => {
  const { data: userInfo } = useUserInfo();
  const { data: participationStatus } = useEventsParticipationStatus(EventTypeEnum.TALENT_POOL_HOLIDAY_2023_10);
  //이벤트 참여 & 이벤트 종료 안됐을 경우
  const isParticipation = participationStatus?.isParticipation && !participationStatus.isEnded;

  // [D] 제휴서비스 신청 안됨
  if (!userInfo) return null;

  if (!userInfo.authorities.includes('PARTNERSHIP') && !isParticipation) return <CompetencyResultSample />;

  return (
    <div className={cx('resultWrap')}>
      {/* [D] 역량 유형 영역 */}
      <CompetencyType sn={sn} />

      {/* [D] 아직 끝이 아니에요 영역 */}
      <NotOverYetBanner />

      {/* [D] 역량 프로파일, 레이더 그래프 영역 */}
      <CompetencyProfile sn={sn} />

      {/* [D] 기업 추천, 바 그래프 영역 */}
      <CompanyRecommend sn={sn} />

      {/* [D] 개발 직무 추천, 레이더 그래프, 바 그래프 영역 */}
      <JobRecommend sn={sn} />

      {/* [D] 면접 예상 질문 및 가이드 영역 */}
      <InterviewGuide sn={sn} />

      {/* [D] 공유하기 영역 */}
      <Share />

      {/* [D] 피드백 영역 */}
      <Feedback sn={sn} />

      {/* [D] 경고 영역 */}
      <CopyrightWarning />
    </div>
  );
};

export default CompetencyResult;
